import { Skeleton } from './Skeleton';

interface SkeletonCardProps {
  className?: string;
  showIcon?: boolean;
  showTitle?: boolean;
  showSubtitle?: boolean;
  showValue?: boolean;
  layout?: 'horizontal' | 'vertical';
}

export function SkeletonCard({
  className = '',
  showIcon = true,
  showTitle = true,
  showSubtitle = true,
  showValue = true,
  layout = 'vertical'
}: SkeletonCardProps) {
  if (layout === 'horizontal') {
    return (
      <div className={`bg-white rounded-lg shadow-md p-4 ${className}`}>
        <div className="flex items-center space-x-4">
          {showIcon && (
            <Skeleton width="48px" height={48} className="rounded-lg flex-shrink-0" />
          )}
          <div className="flex-1 space-y-2">
            {showTitle && <Skeleton width="70%" height={20} />}
            {showSubtitle && <Skeleton width="50%" height={16} />}
            {showValue && <Skeleton width="30%" height={24} />}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white rounded-lg shadow-md p-4 sm:p-6 ${className}`}>
      <div className="space-y-4">
        {showIcon && (
          <div className="flex justify-center">
            <Skeleton width="48px" height={48} className="rounded-lg" />
          </div>
        )}
        <div className="space-y-2">
          {showValue && (
            <div className="flex justify-center">
              <Skeleton width="60%" height={32} />
            </div>
          )}
          {showTitle && (
            <div className="flex justify-center">
              <Skeleton width="80%" height={20} />
            </div>
          )}
          {showSubtitle && (
            <div className="flex justify-center">
              <Skeleton width="60%" height={16} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
